import { getAtan } from "./helper";
import { IOrient, IRotation } from "../types/game-config-type";

export class Orientation implements IOrient {
  get phi(): number {
    return this._phi;
  }

  get theta(): number {
    return this._theta;
  }

  static get zero(): Orientation {
    return new Orientation(0, 0);
  }

  get x(): number {
    return this._x;
  }

  set x(x: number) {
    this._x = x;
  }

  get y(): number {
    return this._y;
  }

  set y(y: number) {
    this._y = y;
  }

  get z(): number {
    return this._z;
  }
  set z(z: number) {
    this._z = z;
  }

  public static copy(orient: Orientation): Orientation {
    return new Orientation(orient.phi, orient.theta);
  }

  // in sphere coordinates
  private _phi: number;
  private _theta: number;

  // in decart coordinates
  private _x: number;
  private _y: number;
  private _z: number;

  constructor(phi = 0, theta = 0) {
    this._phi = phi;
    this._theta = theta;
    this.toDecart();
  }

  public rotate(rotation: IRotation): void {
    this.rotateX(rotation.x);
    this.rotateY(rotation.y);
    this.rotateZ(rotation.z);
  }

  public rotateX(ang: number): void {
    const oldY = this._y;
    this._y = oldY * Math.cos(ang) - this._z * Math.sin(ang);
    this._z = oldY * Math.sin(ang) + this._z * Math.cos(ang);
    this.toSphere();
  }
  public rotateY(ang: number): void {
    const oldX = this._x;
    this._x = oldX * Math.cos(ang) + this._z * Math.sin(ang);
    this._z = -(oldX * Math.sin(ang)) + this._z * Math.cos(ang);
    this.toSphere();
  }

  public rotateZ(ang: number): void {
    const oldX = this._x;
    this._x = oldX * Math.cos(ang) - this._y * Math.sin(ang);
    this._y = oldX * Math.sin(ang) + this._y * Math.cos(ang);
    this.toSphere();
  }

  private toDecart() {
    this._x = Math.sin(this._theta) * Math.cos(this._phi);
    this._y = Math.sin(this._theta) * Math.sin(this._phi);
    this._z = Math.cos(this._theta);
  }

  private toSphere() {
    this._phi = getAtan(this._x, this._y);
    this._theta = Math.acos(this._z);
  }
}
